const SuarteWorldIcon = ({ className = "", onClick = null }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 700 700"
    >
      <path
        d="M538.44,179.77c-3.46.25-6.96.53-10.52.85-.5-.54-1.03-1.09-1.57-1.64-22.76-23.87-50.69-43.58-83.04-57.21-126.03-53.11-271.3,5.99-324.43,132.05-14.01,33.25-20.19,67.79-19.42,101.65.01.41,0,.8.03,1.22-1.4,1.16-2.75,2.3-4.1,3.41-53.81,45.68-80.82,90.31-67.79,122.31,13.47,33.1,67.04,45.99,141.29,39.62,22.56,23.46,50.15,42.77,82.04,56.21,126.06,53.13,271.31-6.02,324.43-132.05,13.2-31.33,19.49-63.86,19.5-95.87,60.25-48.43,91.31-96.45,77.51-130.35-13.03-32-63.52-45.09-133.94-40.21ZM608.82,229.68c3.91,3.69,6.87,7.89,8.79,12.59,7.64,18.77-2.36,43.18-25.74,69.53-38.49,43.36-113.24,91.98-205.21,129.41-95,38.67-185.19,55.98-242.88,50.2-32.09-3.18-54.17-13.54-61.4-31.3-1.91-4.7-2.73-9.78-2.5-15.15.66-14.62,9.06-31.44,23.85-49.24,4.49,24,12.55,47.21,23.81,68.81,57.87,8.73,151.16-7.57,249.28-47.5,95.09-38.7,171.48-90.16,208.22-135.79-7.22-25.12-18.43-48.99-33.19-70.66,25.71,1.99,45.45,8.3,56.96,19.09Z"       style={{ strokeWidth: "0px" }}
      />
    </svg>
  );
};

export default SuarteWorldIcon;
